import type { ScrollMapPoint } from '@gem-sdk/heatmap-react';

const MOCK_HEATMAP_SCROLL_SIDEBAR_DATA = [
  {
    key: 0,
    scrollY: 5,
    timeSpent: 1998.0076999999997,
    percentOfSession: 34.9651538060088,
  },
  {
    key: 1,
    scrollY: 10,
    timeSpent: 1712.3812999999998,
    percentOfSession: 29.966689081845534,
  },
  {
    key: 2,
    scrollY: 15,
    timeSpent: 352.4929,
    percentOfSession: 6.168629111902864,
  },
  {
    key: 3,
    scrollY: 20,
    timeSpent: 438.0813000000001,
    percentOfSession: 7.666426928202674,
  },
  {
    key: 4,
    scrollY: 25,
    timeSpent: 265.7417,
    percentOfSession: 4.650482284512843,
  },
  {
    key: 5,
    scrollY: 30,
    timeSpent: 11.5667,
    percentOfSession: 0.2024173603174613,
  },
  {
    key: 6,
    scrollY: 35,
    timeSpent: 1.6992,
    percentOfSession: 0.02973601620612882,
  },
  {
    key: 7,
    scrollY: 40,
    timeSpent: 1.9677,
    percentOfSession: 0.03443476876694897,
  },
  {
    key: 8,
    scrollY: 45,
    timeSpent: 3.0117,
    percentOfSession: 0.05270477872410438,
  },
  {
    key: 9,
    scrollY: 50,
    timeSpent: 5.0128,
    percentOfSession: 0.08772404780960603,
  },
  {
    key: 10,
    scrollY: 55,
    timeSpent: 10.953899999999999,
    percentOfSession: 0.1916933544728781,
  },
  {
    key: 11,
    scrollY: 60,
    timeSpent: 18.327499999999997,
    percentOfSession: 0.3207314247986263,
  },
  {
    key: 12,
    scrollY: 65,
    timeSpent: 23.2885,
    percentOfSession: 0.4075489721141896,
  },
  {
    key: 13,
    scrollY: 70,
    timeSpent: 10.524500000000002,
    percentOfSession: 0.18417885037747342,
  },
  {
    key: 14,
    scrollY: 75,
    timeSpent: 8.247800000000002,
    percentOfSession: 0.14433657866343536,
  },
  {
    key: 15,
    scrollY: 80,
    timeSpent: 17.149500000000003,
    percentOfSession: 0.30011641356344537,
  },
  {
    key: 16,
    scrollY: 85,
    timeSpent: 46.02120000000001,
    percentOfSession: 0.805371438927434,
  },
  {
    key: 17,
    scrollY: 90,
    timeSpent: 102.51320000000001,
    percentOfSession: 1.7939819777201775,
  },
  {
    key: 18,
    scrollY: 95,
    timeSpent: 440.36749999999995,
    percentOfSession: 7.706435450007317,
  },
  {
    key: 19,
    scrollY: 100,
    timeSpent: 246.92599999999993,
    percentOfSession: 4.3212073550580055,
  },
];

export const MOCK_HEATMAP_SCROLL_ATTENTIONS: ScrollMapPoint[] =
  MOCK_HEATMAP_SCROLL_SIDEBAR_DATA.map((item) => ({
    scrollReachY: item.scrollY,
    cumulativeSum: item.timeSpent,
    percUsers: item.percentOfSession,
  }));

const _MOCK_HEATMAP_SCROLL_INTERACTIONS = [
  {
    key: 0,
    scrollY: 0,
    timeSpent: 2024.567,
    percentOfSession: 7.085988361863656,
  },
  {
    key: 1,
    scrollY: 1,
    timeSpent: 2024.567,
    percentOfSession: 7.085988361863656,
  },
  {
    key: 2,
    scrollY: 2,
    timeSpent: 2024.567,
    percentOfSession: 7.085988361863656,
  },
  {
    key: 3,
    scrollY: 3,
    timeSpent: 1891.7704999999999,
    percentOfSession: 6.6212003585541925,
  },
  {
    key: 4,
    scrollY: 4,
    timeSpent: 2024.567,
    percentOfSession: 7.085988361863656,
  },
  {
    key: 5,
    scrollY: 5,
    timeSpent: 2032.3184999999999,
    percentOfSession: 7.113118626649649,
  },
  {
    key: 6,
    scrollY: 6,
    timeSpent: 2034.2195,
    percentOfSession: 7.119772130275809,
  },
  {
    key: 7,
    scrollY: 7,
    timeSpent: 2030.0824999999995,
    percentOfSession: 7.105292622384475,
  },
  {
    key: 8,
    scrollY: 8,
    timeSpent: 2049.227,
    percentOfSession: 7.1722984089026305,
  },
  {
    key: 9,
    scrollY: 9,
    timeSpent: 416.0590000000001,
    percentOfSession: 1.4562072936329749,
  },
  {
    key: 10,
    scrollY: 10,
    timeSpent: 416.0590000000001,
    percentOfSession: 1.4562072936329749,
  },
  {
    key: 11,
    scrollY: 11,
    timeSpent: 272.0814999999999,
    percentOfSession: 0.9522857689957434,
  },
  {
    key: 12,
    scrollY: 12,
    timeSpent: 182.42800000000003,
    percentOfSession: 0.6384983479815995,
  },
  {
    key: 13,
    scrollY: 13,
    timeSpent: 445.94800000000004,
    percentOfSession: 1.5608188506462732,
  },
  {
    key: 14,
    scrollY: 14,
    timeSpent: 445.94800000000004,
    percentOfSession: 1.5608188506462732,
  },
  {
    key: 15,
    scrollY: 15,
    timeSpent: 440.9725,
    percentOfSession: 1.5434045911555017,
  },
  {
    key: 16,
    scrollY: 16,
    timeSpent: 438.30000000000007,
    percentOfSession: 1.5340508360577054,
  },
  {
    key: 17,
    scrollY: 17,
    timeSpent: 438.30000000000007,
    percentOfSession: 1.5340508360577054,
  },
  {
    key: 18,
    scrollY: 18,
    timeSpent: 438.30000000000007,
    percentOfSession: 1.5340508360577054,
  },
  {
    key: 19,
    scrollY: 19,
    timeSpent: 434.53400000000005,
    percentOfSession: 1.5208698288740563,
  },
  {
    key: 20,
    scrollY: 20,
    timeSpent: 432.653,
    percentOfSession: 1.514286325286047,
  },
  {
    key: 21,
    scrollY: 21,
    timeSpent: 432.154,
    percentOfSession: 1.5125398243342039,
  },
  {
    key: 22,
    scrollY: 22,
    timeSpent: 430.8825,
    percentOfSession: 1.5080895719088163,
  },
  {
    key: 23,
    scrollY: 23,
    timeSpent: 16.921499999999998,
    percentOfSession: 0.05922528227777882,
  },
  {
    key: 24,
    scrollY: 24,
    timeSpent: 16.0975,
    percentOfSession: 0.056341280705997976,
  },
  {
    key: 25,
    scrollY: 25,
    timeSpent: 16.0975,
    percentOfSession: 0.056341280705997976,
  },
  {
    key: 26,
    scrollY: 26,
    timeSpent: 16.0975,
    percentOfSession: 0.056341280705997976,
  },
  {
    key: 27,
    scrollY: 27,
    timeSpent: 11.992999999999999,
    percentOfSession: 0.041975522876659954,
  },
  {
    key: 28,
    scrollY: 28,
    timeSpent: 11.382499999999999,
    percentOfSession: 0.03983877171213057,
  },
  {
    key: 29,
    scrollY: 29,
    timeSpent: 2.263,
    percentOfSession: 0.007920504316674851,
  },
  {
    key: 30,
    scrollY: 30,
    timeSpent: 1.7219999999999998,
    percentOfSession: 0.006027003284716788,
  },
  {
    key: 31,
    scrollY: 31,
    timeSpent: 1.6934999999999998,
    percentOfSession: 0.005927253230353008,
  },
  {
    key: 32,
    scrollY: 32,
    timeSpent: 1.6934999999999998,
    percentOfSession: 0.005927253230353008,
  },
  {
    key: 33,
    scrollY: 33,
    timeSpent: 1.6934999999999998,
    percentOfSession: 0.005927253230353008,
  },
  {
    key: 34,
    scrollY: 34,
    timeSpent: 1.6934999999999998,
    percentOfSession: 0.005927253230353008,
  },
  {
    key: 35,
    scrollY: 35,
    timeSpent: 1.7094999999999998,
    percentOfSession: 0.0059832532608730254,
  },
  {
    key: 36,
    scrollY: 36,
    timeSpent: 1.7094999999999998,
    percentOfSession: 0.0059832532608730254,
  },
  {
    key: 37,
    scrollY: 37,
    timeSpent: 1.9284999999999999,
    percentOfSession: 0.006749753678615752,
  },
  {
    key: 38,
    scrollY: 38,
    timeSpent: 2.2455,
    percentOfSession: 0.00785925428329358,
  },
  {
    key: 39,
    scrollY: 39,
    timeSpent: 2.2455,
    percentOfSession: 0.00785925428329358,
  },
  {
    key: 40,
    scrollY: 40,
    timeSpent: 2.2455,
    percentOfSession: 0.00785925428329358,
  },
  {
    key: 41,
    scrollY: 41,
    timeSpent: 2.2455,
    percentOfSession: 0.00785925428329358,
  },
  {
    key: 42,
    scrollY: 42,
    timeSpent: 2.2455,
    percentOfSession: 0.00785925428329358,
  },
  {
    key: 43,
    scrollY: 43,
    timeSpent: 4.394,
    percentOfSession: 0.015379008381559563,
  },
  {
    key: 44,
    scrollY: 44,
    timeSpent: 3.928,
    percentOfSession: 0.01374800749266408,
  },
  {
    key: 45,
    scrollY: 45,
    timeSpent: 3.928,
    percentOfSession: 0.01374800749266408,
  },
  {
    key: 46,
    scrollY: 46,
    timeSpent: 4.6450000000000005,
    percentOfSession: 0.016257508860342326,
  },
  {
    key: 47,
    scrollY: 47,
    timeSpent: 5.497,
    percentOfSession: 0.01923951048553321,
  },
  {
    key: 48,
    scrollY: 48,
    timeSpent: 5.497,
    percentOfSession: 0.01923951048553321,
  },
  {
    key: 49,
    scrollY: 49,
    timeSpent: 5.497,
    percentOfSession: 0.01923951048553321,
  },
  {
    key: 50,
    scrollY: 50,
    timeSpent: 7.095000000000001,
    percentOfSession: 0.024832513533719874,
  },
  {
    key: 51,
    scrollY: 51,
    timeSpent: 7.095000000000001,
    percentOfSession: 0.024832513533719874,
  },
  {
    key: 52,
    scrollY: 52,
    timeSpent: 6.658499999999999,
    percentOfSession: 0.02330476270109566,
  },
  {
    key: 53,
    scrollY: 53,
    timeSpent: 16.960499999999993,
    percentOfSession: 0.05936178235217134,
  },
  {
    key: 54,
    scrollY: 54,
    timeSpent: 16.960499999999993,
    percentOfSession: 0.05936178235217134,
  },
  {
    key: 55,
    scrollY: 55,
    timeSpent: 16.286499999999997,
    percentOfSession: 0.05700278106651565,
  },
  {
    key: 56,
    scrollY: 56,
    timeSpent: 18.0685,
    percentOfSession: 0.06323978446568251,
  },
  {
    key: 57,
    scrollY: 57,
    timeSpent: 18.0685,
    percentOfSession: 0.06323978446568251,
  },
  {
    key: 58,
    scrollY: 58,
    timeSpent: 18.0685,
    percentOfSession: 0.06323978446568251,
  },
  {
    key: 59,
    scrollY: 59,
    timeSpent: 21.145500000000002,
    percentOfSession: 0.07400929033506322,
  },
  {
    key: 60,
    scrollY: 60,
    timeSpent: 21.3255,
    percentOfSession: 0.0746392906784134,
  },
  {
    key: 61,
    scrollY: 61,
    timeSpent: 24.3665,
    percentOfSession: 0.08528279647912405,
  },
  {
    key: 62,
    scrollY: 62,
    timeSpent: 23.583499999999997,
    percentOfSession: 0.08254229498555073,
  },
  {
    key: 63,
    scrollY: 63,
    timeSpent: 23.583499999999997,
    percentOfSession: 0.08254229498555073,
  },
  {
    key: 64,
    scrollY: 64,
    timeSpent: 23.583499999999997,
    percentOfSession: 0.08254229498555073,
  },
  {
    key: 65,
    scrollY: 65,
    timeSpent: 14.864000000000003,
    percentOfSession: 0.05202402835309545,
  },
  {
    key: 66,
    scrollY: 66,
    timeSpent: 14.864000000000003,
    percentOfSession: 0.05202402835309545,
  },
  {
    key: 67,
    scrollY: 67,
    timeSpent: 7.631500000000002,
    percentOfSession: 0.026710264557094184,
  },
  {
    key: 68,
    scrollY: 68,
    timeSpent: 7.631500000000002,
    percentOfSession: 0.026710264557094184,
  },
  {
    key: 69,
    scrollY: 69,
    timeSpent: 7.631500000000002,
    percentOfSession: 0.026710264557094184,
  },
  {
    key: 70,
    scrollY: 70,
    timeSpent: 7.631500000000002,
    percentOfSession: 0.026710264557094184,
  },
  {
    key: 71,
    scrollY: 71,
    timeSpent: 7.631500000000002,
    percentOfSession: 0.026710264557094184,
  },
  {
    key: 72,
    scrollY: 72,
    timeSpent: 8.842,
    percentOfSession: 0.030947016866124187,
  },
  {
    key: 73,
    scrollY: 73,
    timeSpent: 8.486,
    percentOfSession: 0.029701016187053814,
  },
  {
    key: 74,
    scrollY: 74,
    timeSpent: 8.648000000000001,
    percentOfSession: 0.030268016496068986,
  },
  {
    key: 75,
    scrollY: 75,
    timeSpent: 8.2155,
    percentOfSession: 0.028754265671074787,
  },
  {
    key: 76,
    scrollY: 76,
    timeSpent: 8.2155,
    percentOfSession: 0.028754265671074787,
  },
  {
    key: 77,
    scrollY: 77,
    timeSpent: 8.2155,
    percentOfSession: 0.028754265671074787,
  },
  {
    key: 78,
    scrollY: 78,
    timeSpent: 30.623000000000005,
    percentOfSession: 0.10718055841340433,
  },
  {
    key: 79,
    scrollY: 79,
    timeSpent: 30.478000000000005,
    percentOfSession: 0.10667305813681668,
  },
  {
    key: 80,
    scrollY: 80,
    timeSpent: 46.001000000000005,
    percentOfSession: 0.16100358774695528,
  },
  {
    key: 81,
    scrollY: 81,
    timeSpent: 46.001000000000005,
    percentOfSession: 0.16100358774695528,
  },
  {
    key: 82,
    scrollY: 82,
    timeSpent: 46.001000000000005,
    percentOfSession: 0.16100358774695528,
  },
  {
    key: 83,
    scrollY: 83,
    timeSpent: 46.001000000000005,
    percentOfSession: 0.16100358774695528,
  },
  {
    key: 84,
    scrollY: 84,
    timeSpent: 46.102000000000004,
    percentOfSession: 0.1613570879396129,
  },
  {
    key: 85,
    scrollY: 85,
    timeSpent: 45.379999999999995,
    percentOfSession: 0.1588300865623971,
  },
  {
    key: 86,
    scrollY: 86,
    timeSpent: 45.379999999999995,
    percentOfSession: 0.1588300865623971,
  },
  {
    key: 87,
    scrollY: 87,
    timeSpent: 45.379999999999995,
    percentOfSession: 0.1588300865623971,
  },
  {
    key: 88,
    scrollY: 88,
    timeSpent: 45.379999999999995,
    percentOfSession: 0.1588300865623971,
  },
  {
    key: 89,
    scrollY: 89,
    timeSpent: 331.046,
    percentOfSession: 1.1586616314705886,
  },
  {
    key: 90,
    scrollY: 90,
    timeSpent: 314.763,
    percentOfSession: 1.1016711004107493,
  },
  {
    key: 91,
    scrollY: 91,
    timeSpent: 314.763,
    percentOfSession: 1.1016711004107493,
  },
  {
    key: 92,
    scrollY: 92,
    timeSpent: 314.236,
    percentOfSession: 1.0998265994054963,
  },
  {
    key: 93,
    scrollY: 93,
    timeSpent: 631.3739999999999,
    percentOfSession: 2.2098102043465606,
  },
  {
    key: 94,
    scrollY: 94,
    timeSpent: 626.7014999999999,
    percentOfSession: 2.193456445433762,
  },
  {
    key: 95,
    scrollY: 95,
    timeSpent: 618.1544999999999,
    percentOfSession: 2.1635419291303504,
  },
  {
    key: 96,
    scrollY: 96,
    timeSpent: 616.4754999999999,
    percentOfSession: 2.1576654259276564,
  },
  {
    key: 97,
    scrollY: 97,
    timeSpent: 0,
    percentOfSession: 0,
  },
  {
    key: 98,
    scrollY: 98,
    timeSpent: 0,
    percentOfSession: 0,
  },
  {
    key: 99,
    scrollY: 99,
    timeSpent: 0,
    percentOfSession: 0,
  },
];
